module.exports = __webpack_public_path__ + "ce143818eaf0ebf10bf22e08bc1be40e.png";